import React from 'react'
import { Field, reduxForm } from 'redux-form'
import  validate  from './../validateReg';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, withHandlers, lifecycle } from 'recompose';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import EmailField from '../EmailField';
import TextField from '../TextField';
import PasswordField from '../PasswordField';
import PhoneField from '../PhoneField';
import ProjectCodeField from '../ProjectCodeField';
import RenderCheckbox from '../AmLeader';
import Dropdown from '../Dropdown';


import { MDBContainer, MDBRow, MDBCol, MDBStepper, MDBStep, MDBBtn, MDBCard, MDBCardBody, MDBInput } from "mdbreact";
import { registrationRequest, loginReset } from '../../../redux/reducers/login';
import { COLORS,commonStyles } from '../../../styles/styles';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ScaleLoader from 'react-spinners/ScaleLoader';





const ThirdPageModal = ({ classes, form, pristine, previousPage, submitting, login, ...props }) => {
  const { handleSubmit, dropdowns, handleMultiple, handleSchools } = props;
  return (
    <form className="w-100" onSubmit={handleSubmit}>
    <MDBCol md="12">
    <MDBRow>
      
    </MDBRow>
    <MDBRow>
      <MDBCol md="6">
      {dropdowns.dropdowns.highestSchoolLevel && <Field name="highestSchoolLevel" label="Highest School Level" component={Dropdown}  options={dropdowns.dropdowns.highestSchoolLevel}  depth={10012}/>}
     
      </MDBCol>
      <MDBCol md="6">
      {dropdowns.dropdowns.highestQualification && <Field name="highestQualification" label="Highest Qualification" component={Dropdown}  options={dropdowns.dropdowns.highestQualification}  depth={10013}/>}
      </MDBCol>
    </MDBRow>
    <MDBRow>
      <MDBCol md="6">
      {dropdowns.dropdowns.socioEconomics && <Field name="conSocioEconomicStatus" label="Socio-Economic Status" component={Dropdown}  options={dropdowns.dropdowns.socioEconomics}  depth={10010}/>}
     </MDBCol>
      <MDBCol md="6">
      {dropdowns.dropdowns.race && <Field name="race" label="Population Group" component={Dropdown}  options={dropdowns.dropdowns.race}  depth={10009}/>}
     </MDBCol>
    </MDBRow>
    <MDBRow>
      <MDBCol md="6">
      {dropdowns.dropdowns.disabilities && <Field name="disability" label="Disability Status" component={Dropdown}  options={dropdowns.dropdowns.disabilities}  depth={10009} handleMultiple = {handleMultiple}/>}
      </MDBCol>
      <MDBCol md="6">
      <Field name="rating" label="Disability Rating (0-8)" component={Dropdown} options={props.dropdowns.dropdowns.disability_rating}  depth={10008}/>
      </MDBCol>
    </MDBRow>
    <MDBRow>
      <MDBCol md="6">
      {dropdowns.dropdowns.languages && <Field name="language" label="Home Language" component={Dropdown}  options={dropdowns.dropdowns.languages}  depth={10005}/>}
     </MDBCol>
     <MDBCol md="6">
      {dropdowns.dropdowns.nationality && <Field name="nationality" label="Nationality" component={Dropdown}  options={dropdowns.dropdowns.nationality}  depth={10005}/>}
     </MDBCol>
      

    </MDBRow>
    <MDBRow>
      <MDBCol md="6">
      {dropdowns.dropdowns.languages && <Field name="residenceStatus" label="Residence Status" component={Dropdown}  options={dropdowns.dropdowns.residenceStatus}  depth={10004}/>}
     </MDBCol>
     <MDBCol md="6">
      {dropdowns.dropdowns.socc && <Field name="socc" label="Standard Occupational Category Code" component={Dropdown}  options={dropdowns.dropdowns.socc}  depth={10004}/>}
      </MDBCol>
    
    </MDBRow>
    <MDBRow>
      <MDBCol md="6">
      <Field name="lastSchoolEmis" label="Last School (min 5 chars)" component={TextField} depth={10003}/>
     </MDBCol>
     <MDBCol md="6">
      <Field name="lastSchoolYear" label="Last School Year (YYYY)" component={TextField} depth={10003}/>
      </MDBCol>
    
    </MDBRow>
   
    <MDBRow className="mt-4">
            <MDBCol size="6">
              <MDBBtn 
                  right
                  size="md"
                  className='mt-0 mb-2 float-left danger-color-dark'
                  action
                  onClick={previousPage}
                  type="button">
                PREVIOUS
              </MDBBtn>
            </MDBCol>
            <MDBCol size="6">
              <MDBBtn color="success"
                  right
                  size="md"
                  className='ml-3 mr-2 mt-0 mb-2 float-right'
                  action
                  type="submit">
                NEXT
              </MDBBtn>
            </MDBCol>
          </MDBRow>

  </MDBCol>
  <ReactCSSTransitionGroup
          transitionName="fade"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}>{login.fetchingPageReg && <div style={{backgroundColor:'#FFFFFF', position:'absolute', top:0, left:0, height:'100%', width:'100%', zIndex:12000, textAlign:'center'}}>
          <div style={{position:'absolute', top:"40%", width:'100%'}}>
        <ScaleLoader
         
         height={35}
         width={4}
         radius={2}
         margin='2px'
        color={COLORS.cornerstoneRed}
         loading={true}
       />
       </div>
        </div>}</ReactCSSTransitionGroup>
  </form>

  ) 
}



ThirdPageModal.propTypes = {
  classes: PropTypes.instanceOf(Object),
  handleSubmit: PropTypes.func,
  login: PropTypes.instanceOf(Object),
  form: PropTypes.instanceOf(Object),
};

const mapStateToProps = state => ({
  form: state.form,
  login: state.loginReducer,
  dropdowns: state.dropdownsReducer,
  initialValues: state.loginReducer.user.extendedInfo
});
const mapDispatchToProps = dispatch => ({
  registrationRequest: () => dispatch(registrationRequest()),
  loginReset: () => dispatch(loginReset()),
});


const styles = () => ({
  ...commonStyles,
  halfField: {
    display: 'inline-flex',
    width: '49%',
  },
  firstInRow: {
    marginRight: '2%',
  },
  label: {
    color: '#e84848',
  },
  fullField: {
    width: '100%',
  },
  regFormWrapper: {
    maxWidth: '80%',
    margin: '0 auto',
  },
  rowWrapper: {
    display: 'flex',
  },
  noTopLabel: {
    paddingTop: 10,
    paddingLeft: 14,
  },
  pageNo:{
    textAlign: 'center',
    fontFamily: 'Roboto-Bold',

  }
});

export default compose(
  reduxForm({ form: 'registration',
  destroyOnUnmount: false,        // <------ preserve form data
  forceUnregisterOnUnmount: false,  // <------ unregister fields on unmount
  enableReinitialize : true,   
  validate
 }),
  connect(mapStateToProps, mapDispatchToProps),
 
  withStyles(styles),
  lifecycle({
    componentWillMount() {
        var obj = {};
        obj.highestSchoolLevel = this.props.initialValues.HighestSchoolLevel;
        obj.highestQualification = this.props.initialValues.HighestQualification
        obj.conSocioEconomicStatus = this.props.initialValues.conSocioEconomicStatusID
        obj.race = this.props.initialValues.Race
        obj.disability = this.props.initialValues.conDisabilityStatusID
        obj.socc = this.props.initialValues.SOCC
        obj.language = this.props.initialValues.conLanguageID
        obj.nationality = this.props.initialValues.nationality
        
        this.props.initialize(obj)
     
      
    }
  }),
)(ThirdPageModal);
